<template>
  <v-card class="mx-auto" max-width="344">
    <v-img
      :src="urlImage"
      :lazy-src="`https://picsum.photos/10/6?image=${60}`"
      aspect-ratio="1"
      class="grey lighten-2"
      @click="showDialog"
    >
      <template v-slot:placeholder>
        <v-row class="fill-height ma-0" align="center" justify="center">
          <v-progress-circular
            indeterminate
            color="grey lighten-5"
          ></v-progress-circular>
        </v-row>
      </template>
    </v-img>
    <v-dialog v-model="dialog" fullscreen>
      <div class="body-dialog" @click="showDialog">
        <img class="full-image" :src="urlImage" :alt="name" />
      </div>
    </v-dialog>
  </v-card>
</template>

<script>
export default {
  props: {
    urlImage: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      dialog: false
    }
  },
  methods: {
    showDialog() {
      this.dialog = !this.dialog
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/theme/variables.scss';

.full-image {
  max-width: 95%;
  max-height: 95vh;
}

.body-dialog {
  background-color: rgba($color: #000000, $alpha: 0.7);
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
